import {useContext} from "react";
import "../styles/myStats.css";
import { RpgModeContext } from "../RpgModeContext.js";

const MyStats = () => {
  const { rpgMode, toggleRpgMode } = useContext(RpgModeContext);

  return (
    <div>
      <div id="myStats" className="dialog-box">
        <h1>Nathaniel Gomez</h1>
        <div className="double-line">
          <div className="divider-line thick"></div>
          <div className="divider-line thin"></div>
        </div>
        <h2 className="description-right-padding">
          Senior Full-Stack Engineer
          <br />
          UI/UX • APIs • Optimization
        </h2>
        <span className="dialog-prompt">▼</span>
      </div>
      <button className="rpg-toggle" onClick={toggleRpgMode}>
        RPG MODE: {rpgMode ? "ON" : "OFF"}
      </button>
    </div>
  );
};

export default MyStats;
